import Image from "next/image";
import { useViewport } from "../../../../../platform/utils/useViewport";

export const IndustryHeroImage = ({ id, img, alt }) => {
  const { desktop_small_min } = useViewport();
  const deviceSpecificProps = desktop_small_min
    ? {
        width: 1066,
        height: 208,
        priority: true,
        src: img.desktop,
      }
    : {
        width: 85,
        height: 532,
        src: img.mobile,
      };

  return <Image id={id} alt={alt} {...deviceSpecificProps} />;
};
